export default () => {

    if(document.querySelector('[data-filter-tabl]')){
        const setFilterTabl = document.querySelectorAll('[data-filter-tabl]');

        setFilterTabl.forEach(box => {

            let menu = box.querySelectorAll('.th-sel');

            menu.forEach(menuBox => {
                let capMenu = menuBox.querySelector('.th-sel__cap');

                let btnCloseMenu = menuBox.querySelector('.th-sel__body-close');

                capMenu.addEventListener('click', ()=> {
                    menuBox.classList.toggle('active');
                    let thisMenuBox = menuBox;

                    menu.forEach(menuBox => {
                        if(menuBox != thisMenuBox && menuBox.classList.contains('active')){
                            menuBox.classList.remove('active');
                        }
                    });
                });

                btnCloseMenu.addEventListener('click', ()=> {
                    menuBox.classList.toggle('active');
                });

                let menuList = menuBox.querySelectorAll('.th-sel__body-list-item button');

                menuList.forEach(button => {
                    button.addEventListener('click', function(e) {

                        menu.forEach(menuBox => {
                            menuBox.classList.remove('active');
                        });

                        let isActiveBtn = this.classList.contains('active');
                        if (isActiveBtn) return;

                        for (let btn of menuList) {
                            btn.classList.remove('active');
                        }

                        this.classList.add('active');
                    });
                });

            });
        });
    }
    
}
